import * as React from "react";
function SvgGridCol(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.875 21.454C2.841 21.454 2 20.636 2 19.63V3.824C2 2.818 2.84 2 3.875 2h1.25C6.159 2 7 2.818 7 3.824V19.63c0 1.006-.84 1.824-1.875 1.824h-1.25zm0-18.238a.617.617 0 00-.625.608V19.63c0 .335.28.608.625.608h1.25a.617.617 0 00.625-.608V3.824a.617.617 0 00-.625-.608h-1.25zm7.5 18.238c-1.033 0-1.874-.818-1.874-1.824V3.824C9.5 2.818 10.34 2 11.376 2h1.25c1.034 0 1.875.818 1.875 1.824V19.63c0 1.006-.841 1.824-1.875 1.824h-1.25zm0-18.238a.617.617 0 00-.624.608V19.63c0 .336.28.608.625.608h1.25a.617.617 0 00.625-.608V3.824a.617.617 0 00-.625-.608h-1.25zM17 19.63c0 1.006.84 1.824 1.875 1.824h1.25c1.034 0 1.875-.818 1.875-1.824V3.824C22 2.818 21.16 2 20.125 2h-1.25C17.841 2 17 2.818 17 3.824V19.63zm1.25-15.806c0-.335.28-.608.625-.608h1.25c.345 0 .625.273.625.608V19.63c0 .336-.28.608-.625.608h-1.25a.617.617 0 01-.625-.608V3.824z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgGridCol);
export default ForwardRef;
